import { useState } from 'react';
import Modal from '@/common/Modal';
import EditableDropdown, { IDropdownOption } from '@/common/EditableDropdown';
import { TourBagIronDetail, TourBagIronSet } from '@/api/models';
import clubStyles from '../Club.module.scss';
import styles from './AddIronToSetModal.module.scss';

interface IAddIronToSetModal {
  iron: TourBagIronDetail;
  ironSets: TourBagIronSet[];
  // eslint-disable-next-line no-unused-vars
  handleAddIronToSet: (selectedSet: TourBagIronSet) => Promise<void>;
  showAddIronToSetModal: boolean;
  closeAddIronToSetModal: () => void;
  isUtility?: boolean;
}

function AddIronToSetModal({ iron, ironSets, handleAddIronToSet, showAddIronToSetModal, closeAddIronToSetModal, isUtility }: IAddIronToSetModal) {
  const setsDropdownData: IDropdownOption[] = ironSets.map((set) => ({ id: set.tourBagIronSetId.toString(), label: set.tourBagIronSetName }));
  const [showErrors, setShowErrors] = useState(false);
  const [selectedSet, setSelectedSet] = useState<TourBagIronSet>(ironSets[0]);

  const onAddIronToSet = () => {
    if (!selectedSet) throw new Error('Missing set');
    const hasSameClubType = selectedSet?.tourBagIronDetails.some((setIron) => setIron.ironClubId === iron.ironClubId);
    if (hasSameClubType) {
      setShowErrors(true);
      return;
    }
    handleAddIronToSet(selectedSet);
  };

  return (
    <Modal isOpen={showAddIronToSetModal} onClose={closeAddIronToSetModal} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.title}>Add {isUtility ? 'Utility' : 'Iron'} to Set</div>
        <div className={styles.subtitle}>
          Selected {isUtility ? 'Utility' : 'Iron'}: {iron.familyName} {iron.headModelName} {iron.ironClubName}
        </div>
        <div className={styles.warning}>Set values will replace: Hand, Grip Type, Grip Size, Round/Rib, Logo, Grip Tape.</div>

        <EditableDropdown
          type="rectangle"
          variant="large"
          initialId={selectedSet.tourBagIronSetId.toString()}
          onChange={(tourBagIronSetId) => {
            const set = ironSets.find((ironSet) => ironSet.tourBagIronSetId.toString() === tourBagIronSetId);
            if (set) setSelectedSet(set);
          }}
          options={setsDropdownData}
          alignment="left"
          className={styles.dropdown}
        />
        {showErrors && <div className={clubStyles.errors}>You can only add one club per iron number (e.g., only one 3-iron).</div>}
        <div className={styles.buttons}>
          <button onClick={closeAddIronToSetModal}>Close</button>
          <button onClick={onAddIronToSet}>Add</button>
        </div>
      </div>
    </Modal>
  );
}

export default AddIronToSetModal;
